import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'issue-create.modal.error-state.header',
		defaultMessage: "Something's gone wrong",
		description: 'Header for error state for issue create dialog',
	},
	description: {
		id: 'issue-create.modal.error-state.description',
		defaultMessage:
			'Our team has been notified. If the problem persists, please contact Atlassian support.',
		description: 'Description for error state for issue create dialog',
	},
});
